import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderItem, OrderItemStatus } from 'src/interfaces/order-item';
import { MatSelectChange } from '@angular/material/select';
import { LoaderService } from 'src/core/services/loader.service';
import { BatchStatus } from 'src/interfaces/batch';
import { DirtinessService } from 'src/core/services/dirtiness.service';
import { BatchService } from 'src/core/services/batch.service';
import { Order, RawOrderItem } from 'src/interfaces/order';

@Component({
    selector: 'app-batch-order-item-list',
    templateUrl: './batch-order-item-list.component.html',
    styleUrls: ['./batch-order-item-list.component.scss'],
    standalone: false
})
export class BatchOrderItemListComponent implements OnInit {

  displayedColumns: string[] = [
    'name',
    //'dosage',
    //'status',
    'quantity',
    'fulfilled',
    'details'
  ];

  @Input() orderItems: RawOrderItem[];
  @Input() order: Order;
  @Input() orderItemStatuses: OrderItemStatus[] = [];
  @Input() batchStatuses: BatchStatus[] = [];
  newBatchStatusCode: string = "AWM";
  statusCodes: {
    awaitingFulfilment: string,
    awaitingManufacture: string,
    inStock: string,
    procured: string,
    packed: string,
  } = {
      awaitingFulfilment: "AWF",
      awaitingManufacture: "AWM",
      inStock: "ISK",
      procured: "PRC",
      packed: "PKD",
    };
  @Output() onDelete = new EventEmitter<OrderItem>();
  isLoading: boolean = false;
  selectedItem: OrderItem | null = null;


  constructor(
    private _loaderService: LoaderService,
    private _dirtinessService: DirtinessService,
    private _batchService: BatchService
  ) { }

  ngOnInit(): void {
    this
      ._loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });
  }

  deleteOrderItem(item: OrderItem) {
    this.onDelete.emit(item);
  }

  changeOrderItemStatus(event: MatSelectChange, orderItem: OrderItem) {
    this._dirtinessService.setDirty(true);
    orderItem.status = event.value;
  }

  getTotalPrice(item: OrderItem): number {
    return item.medicineDosagePackageType.price * item.quantity;
  }

  getStatus(orderItem: OrderItem) {
    const orderItemStatus: OrderItemStatus | undefined = this
      .orderItemStatuses
      .find((orderItemStatus: OrderItemStatus) => {
        if (!orderItem.status) return false;
        return orderItemStatus.id === orderItem.status.id;
      })
    if (!orderItemStatus) return null;
    return orderItemStatus;
  }

  disableStatus(status: OrderItemStatus): boolean {
    return (
      status.code === 'PRC'
      ||
      status.code === 'PKD'
    )
  }

  async printLabels(orderItems: OrderItem[]) {

    const success: boolean = await this._batchService
      .openPrintLabelsDialog(
        "Print labels",
        "Click the 'Print' button to start printing.",
        orderItems,
        this.order
      );
  }

  async openDetails(item: RawOrderItem) {
    await this._batchService.openOrderItemDetailsDialog(null, item);
  }

}
